module.exports = __webpack_public_path__ + "static/apple-icon-120x120.8ef2c8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/favicon/apple-icon-120x120.png
// module id = 137
// module chunks = 915738553496 35783957827783